export const MEDICINE_BENEFITS = [
  {
    img: '/assets/svgs/multi-capsule.svg',
    title: 'Superior, Quality-Checked Medicine',
  },
  {
    img: '/assets/svgs/delivery-boy.svg',
    title: 'Privacy-Focused Brown Packaging',
  },
  {
    img: '/assets/svgs/parcel.svg',
    title: 'Free Home Delivery with Allo Health',
  },
];

export const LABTEST_BENEFITS = [
  {
    img: '/assets/svgs/report-tab.svg',
    title: 'Lab Report Doctor Discussion',
  },
  {
    img: '/assets/svgs/allo-trusted.svg',
    title: 'Allo trusted medicine brands',
  },
  {
    img: '/assets/svgs/urine-sample.svg',
    title: 'Private At-home Sample Pickup',
  },
];

export const COUNSELLING_BENEFITS = [
  {
    img: '/assets/svgs/counselling-hand.svg',
    title: 'Improve Sexual Perfromance',
  },
  {
    img: '/assets/svgs/champagne-glass.svg',
    title: 'Stenghthen Sexual Intimacy',
  },
  {
    img: '/assets/svgs/couple-counselling.svg',
    title: 'Overcome anxiety for better sex',
  },
];

//in minutes
export const LAB_BOOKING_OFFSET = 3 * 24 * 60; //3 days
export const CONSULTATION_BOOKING_OFFSET = 5 * 24 * 60; //5 days
export const CONSULTATION_JOINING_ALLOWED_OFFSET = 5; //5 minutes
export const CONSULTATION_RESCHEDULE_ALLOWED_OFFSET = 2 * 60; //2 hours

export const INTERNAL_MEMBERS = [
  '+919538281474',
  '+917507599227',
  '+919462181161',
  '+919833756835',
  '+919920698762',
  '+919302426391',
  '+918097575363',
  '+918127023283',
  '+917259356897',
  '+918858602288',
  '+917483937991',
];
